import * as echarts from "echarts";
export default {
  data() {
    return {
      barChart:null,
      myChart:null,
      barChart1:null, //主体属性
      myChartLine:null,//多列柱状图
      placeType:{
        1:"生产基地/企业",
        2:"屠宰场",
        3:"农贸市场",
        4:"批发市场",
        5:"超市",
        6:"其他",
        7:'种养殖散户',
        8:'合作社',
        9:'养殖场'
      }
    }
  },
  methods: {
    // 右侧多列柱装退
    initLinesChart(element, data) { 
      //  if(this.myChartLine) {
      //   this.myChartLine.destroy();
      //  }
       this.myChartLine = echarts.init(element);
       var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "none" },
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '4%',
          top: '8%',
          containLabel: true
        },
        legend: {
          data: ['例行检测数', '专项检测数','监督抽查数'],
          right: 10,
          top: 0,
          textStyle: {
            color: "#fff"
          },
          itemWidth: 12,
          itemHeight: 10,
        },
        xAxis: {
          type: 'category',
          data: data.yearCount.map(ele => ele.year),
          axisLine: {

            lineStyle: {
              color: 'white'

            }
          },
          axisLabel: {
            textStyle: {
              fontFamily: 'Microsoft YaHei',
              color: "white"
            }
          },
        },

        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: 'white'
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {
            textStyle: {
              fontFamily: 'Microsoft YaHei',
              color: "white"
            }
          }
        },
        series: [{
          name: '例行检测数',
          type: 'bar',
          barWidth: '15%',
          itemStyle: {
            normal: {
              color: "#12FF75",
            },
          },
          data: data.yearCount.map(ele => ele.lxjc),
        },
        {
          name: '专项检测数',
          type: 'bar',
          barWidth: '15%',
          itemStyle: {
            normal: {
              color: "#2CD8DC"
            }
          },
          data: data.yearCount.map(ele => ele.zxjc),
        },{
          name: '监督抽查数',
          type: 'bar',
          barWidth: '15%',
          itemStyle: {
            normal: {
              color: "#5070dd"
            }
          },
          data: data.yearCount.map(ele => ele.jdcc),
        }]
      };
      this.myChartLine.setOption(option);
      // this.myChartLine.setOption(option)
    },
    // 主体行业统计
    initRightBuession(element, data,enumType) {
      if(this.myChart1) {
        this.myChart1.dispose();
      }
      this.myChart1 = echarts.init(element);
      var m2R2Data = data.businessCount.map(ele => {
        return {
          value: ele.value,
          legendname: enumType[+ele.label],
          name: enumType[+ele.label] + "  " + ele.value,
        }
      })
      let option = {
        tooltip: {
          trigger: "item",
          formatter: '{b}:({d}%)'
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          left: "60%",
          icon: "circle",
          align: "left",
          top: "middle",
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
          },
          height: 120,
        },
        series: [
          {
            name: "行业统计",
            type: "pie",
            center: ["35%", "50%"],
            radius: ['60%','90%'],
            clockwise: false, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            data: m2R2Data,
          },
        ],
      };

      this.myChart1.setOption(option);
    },
    // 主体属性统计
    rightBarSubject(element, data,subjectAttribute) {
      if(this.barChart1) {
        this.barChart1.dispose();
      }
      this.barChart1= echarts.init(element);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: "15%",
          right: "3%",
          left: "5%",
          bottom: "12%",
        },
        xAxis: [
          {
            type: "category",
            data: data.attributeCount.map(ele => {
              return subjectAttribute[+ele.label]||'其他'
            }),
            axisLine: {
              lineStyle: {
                color: "#FFFFFF",
              },
            },
            axisLabel: {
              color: "#e2e9ff",
              textStyle: {
                fontSize: 12,
              },
              formatter: function (value) {
                return value.length > 3 ? value.substring(0, 3) + "..." : value;
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            axisLabel: {
              formatter: "{value}",
              color: "#e2e9ff",
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(0,186,255,.6)",
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,0.12)",
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: data.attributeCount.map(ele => ele.value),
            barWidth: "20px",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0EECE4", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#058FE7", // 100% 处的颜色
                    },
                  ],
                  false
                ),
                //shadowColor: 'rgba(0,160,221,1)',
                //shadowBlur: 4,
              },
            },
            label: {
              normal: {
                show: false,
                lineHeight: 30,
                formatter: "{c}",
                position: "top",
                textStyle: {
                  color: "#00D6F9",
                  fontSize: 20,
                },
              },
            },
          },
        ],
      };
      this.barChart1.setOption(option);
      //
    },
    // 右侧 第二种模式 第一个饼图
    initRightOnePie(element, data,size =0) {
      if(this.myChart && size) {
        this.myChart.dispose();
      }
      // if(this.myChart && size  == 0) {
      //   this.myChart.dispose();
      // }
      this.myChart = echarts.init(element);

      var m2R2Data = [
        {
          value: 335,
          legendname: "种类01",
          name: "种类01  335",
          itemStyle: { color: "#0990DD" },
        },
        {
          value: 310,
          legendname: "种类02",
          name: "种类02  310",
          itemStyle: { color: "#2CD8DC" },
        },
        {
          value: 234,
          legendname: "种类03",
          name: "种类03  234",
          itemStyle: { color: "#A5DFF7" },
        },
        {
          value: 154,
          legendname: "种类04",
          name: "种类04  154",
          itemStyle: { color: "#F8E390" },
        },
      ];
      if (data) {
        m2R2Data = m2R2Data.slice(0, 2);
      }
      let option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          left: "60%",
          icon: "circle",
          align: "left",
          top: "middle",
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
          },
          height: 120,
        },
        series: [
          {
            name: "标题",
            type: "pie",
            center: ["35%", "50%"],
            radius: size?['60%','80%']:["60%", "90%"],
            clockwise: false, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            data: m2R2Data,
          },
        ],
      };

      this.myChart.setOption(option);
    },
    // 右侧柱状图
    rightBar(element, data) {
      if(this.barChart) {
        this.barChart.dispose();
      }
      this.barChart = echarts.init(element);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: "15%",
          right: "3%",
          left: "5%",
          bottom: "12%",
        },
        xAxis: [
          {
            type: "category",
            data: data.placeCount.map(ele => {
              return this.placeType[+ele.label]
            }),
            axisLine: {
              lineStyle: {
                color: "#FFFFFF",
              },
            },
            axisLabel: {
              color: "#e2e9ff",
              textStyle: {
                fontSize: 12,
              },
              formatter: function (value) {
                return value.length > 3 ? value.substring(0, 3) + "..." : value;
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            axisLabel: {
              formatter: "{value}",
              color: "#e2e9ff",
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(0,186,255,.6)",
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,0.12)",
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: data.placeCount.map(ele => ele.value),
            barWidth: "20px",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0EECE4", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#058FE7", // 100% 处的颜色
                    },
                  ],
                  false
                ),
                //shadowColor: 'rgba(0,160,221,1)',
                //shadowBlur: 4,
              },
            },
            label: {
              normal: {
                show: false,
                lineHeight: 30,
                formatter: "{c}",
                position: "top",
                textStyle: {
                  color: "#00D6F9",
                  fontSize: 20,
                },
              },
            },
          },
        ],
      };
      this.barChart.setOption(option);
      //
    },
  },
};
